var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.709677,
    y: 0.709677,
    width: 24.5806,
    height: 24.5806,
    rx: 3.52109,
    fill: "white",
    stroke: "#004BA5",
    strokeWidth: 1.41935
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8372 6.60743C20.9415 6.71202 21 6.85368 21 7.00136C21 7.14905 20.9415 7.29071 20.8372 7.3953L19.6731 8.56037L17.4409 6.32844L18.605 5.16337C18.7096 5.05876 18.8515 5 18.9995 5C19.1475 5 19.2894 5.05876 19.3941 5.16337L20.8372 6.60631V6.60743ZM18.884 9.34824L16.6518 7.11631L9.04774 14.7205C8.98631 14.7819 8.94007 14.8568 8.91269 14.9392L8.01422 17.6332C7.99793 17.6823 7.99561 17.7349 8.00754 17.7853C8.01947 17.8357 8.04516 17.8817 8.08176 17.9183C8.11835 17.9549 8.1644 17.9806 8.21476 17.9925C8.26511 18.0044 8.31779 18.0021 8.36691 17.9858L11.0612 17.0875C11.1435 17.0604 11.2184 17.0146 11.28 16.9535L18.884 9.34935V9.34824Z",
    fill: "#004BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19.3929C5 19.8191 5.16932 20.2279 5.47072 20.5293C5.77212 20.8307 6.1809 21 6.60714 21H18.3929C18.8191 21 19.2279 20.8307 19.5293 20.5293C19.8307 20.2279 20 19.8191 20 19.3929V12.9643C20 12.8222 19.9436 12.6859 19.8431 12.5855C19.7426 12.485 19.6064 12.4286 19.4643 12.4286C19.3222 12.4286 19.1859 12.485 19.0855 12.5855C18.985 12.6859 18.9286 12.8222 18.9286 12.9643V19.3929C18.9286 19.5349 18.8721 19.6712 18.7717 19.7717C18.6712 19.8721 18.5349 19.9286 18.3929 19.9286H6.60714C6.46506 19.9286 6.3288 19.8721 6.22834 19.7717C6.12787 19.6712 6.07143 19.5349 6.07143 19.3929V7.60714C6.07143 7.46506 6.12787 7.3288 6.22834 7.22834C6.3288 7.12787 6.46506 7.07143 6.60714 7.07143H13.5714C13.7135 7.07143 13.8498 7.01499 13.9502 6.91452C14.0507 6.81406 14.1071 6.67779 14.1071 6.53571C14.1071 6.39363 14.0507 6.25737 13.9502 6.15691C13.8498 6.05644 13.7135 6 13.5714 6H6.60714C6.1809 6 5.77212 6.16932 5.47072 6.47072C5.16932 6.77212 5 7.1809 5 7.60714V19.3929Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.3af708c99b43bc0c0e96d5dcf7ca4dfe.svg";
export { ForwardRef as ReactComponent };